import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FAILED, STARTED } from 'conversations-async-data/async-data/constants/asyncStatuses';
import { PIPELINE_ID, PIPELINE_STAGE_ID } from 'svh-tickets-lib/tickets/public/constants';
import { getAccessLevelFromPipeline, getIdFromPipeline, getIdFromStage, getLabelFromPipeline, getLabelFromStage } from 'svh-tickets-lib/tickets/public/operators';
import TicketPipelineStageInput from './TicketPipelineStageInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MODAL_WIDTH = 500;
const ChangePipelineModal = ({
  onChangePipeline,
  onChangeStage,
  onConfirm,
  onReject,
  pipelineChangeStatus,
  pipelineOptions,
  stageOptions,
  toPipeline,
  toStage
}) => {
  const accessLevel = getAccessLevelFromPipeline(toPipeline);
  const canEdit = accessLevel === undefined ||
  // not all portal have pipeline permissions access so we don't always get this value
  accessLevel.toLowerCase() === 'not_specified';
  const header = /*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.header"
      })
    }), /*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onReject
    })]
  });
  const body = /*#__PURE__*/_jsxs(DialogBody, {
    children: [/*#__PURE__*/_jsx(TicketPipelineStageInput, {
      canEditProperty: canEdit,
      label: `${PIPELINE_ID}_${getLabelFromPipeline(toPipeline)}`,
      onChange: onChangePipeline,
      options: pipelineOptions,
      value: getIdFromPipeline(toPipeline)
    }), /*#__PURE__*/_jsx(TicketPipelineStageInput, {
      canEditProperty: canEdit,
      label: `${PIPELINE_STAGE_ID}_${getLabelFromStage(toStage)}`,
      onChange: onChangeStage,
      options: stageOptions,
      value: getIdFromStage(toStage)
    })]
  });
  const footer = /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(LoadingButton, {
      "data-selenium-test": "change-pipeline-modal-save-button",
      use: "primary",
      onClick: onConfirm,
      loading: pipelineChangeStatus === STARTED,
      failed: pipelineChangeStatus === FAILED,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.buttons.confirm"
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onReject,
      "data-selenium-test": "change-pipeline-modal-cancel-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.buttons.cancel"
      })
    })]
  });
  return /*#__PURE__*/_jsxs(Modal, {
    width: MODAL_WIDTH,
    children: [header, body, footer]
  });
};
ChangePipelineModal.displayName = 'ChangePipelineModal';
export default ChangePipelineModal;